import Phaser from 'phaser';
import { SCENES } from '../utils/constants';

export class MainMenuScene extends Phaser.Scene {
  private startButton!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: SCENES.MAIN_MENU });
  }

  create() {
    const { width, height } = this.cameras.main;

    // Add video background
    const video = this.add.video(width / 2, height / 2, 'pond-bg');
    video.setOrigin(0.5, 0.5);

    // Wait for video metadata to load before scaling
    video.on('created', () => {
      // Calculate scale to cover entire screen (like CSS background-size: cover)
      const videoWidth = video.width;
      const videoHeight = video.height;
      const scaleX = width / videoWidth;
      const scaleY = height / videoHeight;
      const scale = Math.max(scaleX, scaleY);

      video.setScale(scale);
    });

    // Set video to loop and mute (required for autoplay in browsers)
    video.setMute(true);
    video.setLoop(true);
    video.play();

    // Add logo
    const logo = this.add.image(width / 2, height / 3, 'logo');
    logo.setOrigin(0.5);
    // Scale logo to reasonable size (adjust as needed)
    const logoScale = Math.min(width * 0.6 / logo.width, 200 / logo.height);
    logo.setScale(logoScale);

    this.startButton = this.add
      .text(width / 2, height / 2 + 80, 'Start', {
        fontSize: '32px',
        color: '#88ff88',
        fontStyle: 'bold',
      })
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true });

    this.startButton.on('pointerover', () => {
      this.startButton.setScale(1.1);
      this.startButton.setColor('#aaffaa');
    });

    this.startButton.on('pointerout', () => {
      this.startButton.setScale(1);
      this.startButton.setColor('#88ff88');
    });

    this.startButton.on('pointerdown', () => {
      this.scene.start(SCENES.POKEMON_DEMO);
    });
  }
}
